import React, { useState } from 'react'
import { CREATE_PAYMENT_REQUEST, VERIFY_PAYMENT_ORDER } from '../../Utils/apis';
import { useDispatch } from 'react-redux';
// import { updateCoinsDetails } from '../../Store/Slices/user';


const useCreatePaymentRequest = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [paymentStatus, setPaymentStatus] = useState(undefined);
  const [coinsDetails, setCoinsDetails] = useState({ boughtCoins: 0, totalCoins: 0 });

  const createFunction = async (params) => {
    try {
      setLoading(true);
      const res = await fetch(CREATE_PAYMENT_REQUEST, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: 'include',
        body: JSON.stringify({
          couponCode: params.coupon_code,
          currency: 'INR',
          type: params.plan_type,
          planName: params.plan_name,
        }
        ) // amount in INR
      });

      if (res.ok) {
        const orderDetails = await res.json();
        if (orderDetails?.success === true && !orderDetails?.data) {
          setPaymentStatus(true);
          setLoading(false);
          return;
        }
        const { amount, currency, id } = orderDetails?.data;
        const option = {
          amount,
          currency,
          order_id: id,
          desciption: "lorem ihdfh ijhti r irhour orh ourh uooir po",
          key: 'rzp_live_KdkDjpbix8dMP7', // APP Api Key
          name: 'Zepcruit',
          handler: async (params) => {
            // console.log("params in verify payment", params);
            try {
              setLoading(true);
              const res = await fetch(VERIFY_PAYMENT_ORDER, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                credentials: 'include',
                body: JSON.stringify(params),
              })

              if (res.ok) {
                const data = await res.json();
                setPaymentStatus(data?.success);
                setCoinsDetails({ boughtCoins: data?.receivedCoins, totalCoins: data?.availableCoins });
                // dispatch(updateCoinsDetails(data?.availableCoins))
              }
              else {
                setPaymentStatus(false);
              }
            } catch (err) {

            } finally {
              setLoading(false);
            }
          },
          theme: {
            color: "#3399cc"
          },
          modal: {
            ondismiss: () => { setPaymentStatus(false); setLoading(false); }
          }
        };
        
        const rzp = new window.Razorpay(option);
        rzp.open();
      }
      else{
        throw new Error('Error While requesting for payment')
      }
    } catch (err) {
      setError(err);
    }
    finally {
      setLoading(false);
    }
  }

  return [loading, error, paymentStatus, createFunction, coinsDetails];
}

export default useCreatePaymentRequest;


//-------------------------------------------------- Working of Razorpay:---------------------

// First We have to create a Order to our backend using CREATE_PAYMENT_REQUEST api, the request will return an orderId to us. We need that orderId;

// After that we have to create an instance of Razorpay Class which, we have to enable that JS class in our app using npm or external script. that class will take an object for its constructer.
// constructor object will have amount, currency, order_id ( provided by backend), desciption (), key: 'That will ba app key for razorpay to verify  our app', name: (), An handler function to handle after payemt fuilfiledd or faild, ( We are verifiying the payment fron backend ),

// After our order is created and an instance of Razorpay class is created we have to open the request using instance of Razorpay.